import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FeahterIconModule } from "src/app/core/feather-icon/feather-icon.module";
import {
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgApexchartsModule } from "ng-apexcharts";
import { MatSelectFilterModule } from "mat-select-filter";
import { MatSelectModule } from "@angular/material/select";
import { ChartsModule } from "ng2-charts";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTreeModule } from "@angular/material/tree";
import { MatRadioModule } from "@angular/material/radio";
import { ArchwizardModule } from "angular-archwizard";
import { FarmerService } from "src/app/services/farmer.service";
import {
  NgbCarouselConfig,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";
import { FarmertimelineComponent } from "./farmertimeline.component";

@NgModule({
  declarations: [FarmertimelineComponent],
  imports: [
    CommonModule,
    FormsModule,
    FeahterIconModule,
    NgbDropdownModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    NgApexchartsModule,
    ChartsModule,
    MatSelectModule,
    MatSelectFilterModule,
    NgxDatatableModule,
    MatTabsModule,
    MatTreeModule,
    MatRadioModule,
    NgbModule,
    ArchwizardModule,
  ],
  providers: [FarmerService],
  exports: [FarmertimelineComponent],
})
export class FarmertimelineModule {}
